//Types should be in const to avoid typos and duplication since it's a string and could be easily miss spelled
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SUB_QUANTITY = 'SUB_QUANTITY';
export const ADD_QUANTITY = 'ADD_QUANTITY';
export const ADD_SHIPPING = 'ADD_SHIPPING';
export const ADD_QUANTITY_WITH_NUMBER = 'ADD_QUANTITY_WITH_NUMBER';
export const ORDER_FORM = 'ORDER_FORM';
export const CHECKOUT_CHARGE = 'CHECKOUT_CHARGE';
export const RESET_CART = 'RESET_CART';
export const ADD_PRODUCTS = 'ADD_PRODUCTS';
export const ADD_SUBPRODUCTS = 'ADD_SUBPRODUCTS';
export const ADD_SINGLE_PRODUCT = 'ADD_SINGLE_PRODUCT';
export const ADD_SINGLE_SUBPRODUCT = 'ADD_SINGLE_SUBPRODUCT';
export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const EDIT_SUBPRODUCT = 'EDIT_SUBPRODUCT';
export const REMOVE_SUBPRODUCT = 'REMOVE_SUBPRODUCT';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const ADD_FEED = 'ADD_FEED';
